export default "__VITE_ASSET__DDQR1noc__"